import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';

UIkit.use(Icons);

document.addEventListener('DOMContentLoaded', () => {


})
